module.exports = __webpack_public_path__ + "img/starter-icon.51f9eafc.svg";